import { PATTERNS_GROUP_NAME } from './patternSubcategories'

export const STOCK_INDICATOR_GROUP_NAME = 'Stock'
export const FNO_INDICATOR_GROUP_NAME = 'F&O'

const getIndicatorGroupSortKey = (groupName: string): [number, string] => {
    if (groupName === STOCK_INDICATOR_GROUP_NAME) return [0, groupName]
    if (groupName === FNO_INDICATOR_GROUP_NAME) return [1, groupName]
    if (groupName === PATTERNS_GROUP_NAME) return [3, groupName]
    return [2, groupName]
}

export const sortIndicatorGroupNames = (groups: Iterable<string>): string[] => {
    return Array.from(new Set(groups)).sort((a, b) => {
        const [aRank, aName] = getIndicatorGroupSortKey(a)
        const [bRank, bName] = getIndicatorGroupSortKey(b)
        if (aRank !== bRank) return aRank - bRank
        return aName.localeCompare(bName)
    })
}

export const getDefaultIndicatorGroupName = (groups: Iterable<string>): string | undefined => {
    const sorted = sortIndicatorGroupNames(groups)
    if (sorted.includes(STOCK_INDICATOR_GROUP_NAME)) {
        return STOCK_INDICATOR_GROUP_NAME
    }
    return sorted[0]
}
